export const fromHexToBase64 = (str: string): string => {
  const matchArr = str.match(/\w{2}/g) || [];

  return window.btoa(
    matchArr
      .map((a) => String.fromCharCode(parseInt(a, 16)))
      .join('')
  );
};
